
import { Record, Union } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { record_type, int32_type, float64_type, string_type, union_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { map as map_1, length, empty as empty_1, singleton as singleton_1, replicate, item, tryFind, ofArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { unwrap, defaultArgWith, defaultArg } from "../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { createElement } from "react";
import React from "react";
import { parse, min, max } from "../fable_modules/fable-library-js.5.0.0-rc.2/Double.js";
import { map, append, empty, singleton, collect, delay, toList } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { reactApi, reactElement } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { rangeDouble } from "../fable_modules/fable-library-js.5.0.0-rc.2/Range.js";
import { item as item_1 } from "../fable_modules/fable-library-js.5.0.0-rc.2/Array.js";
import { equals, round, int32ToString, createObj } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { filter, replace, printf, toText, join } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { Toggle } from "../Components/Toggle.js";
import { useTranslation } from "react-i18next";
import { LabelConfig, generateRangeCodes, LabelData, generate, parseExcelFile, downloadTemplate, TextAlign, LogoCorner, CodeType } from "./PdfGenerator.js";
import { isDigit } from "../fable_modules/fable-library-js.5.0.0-rc.2/Char.js";
import { parse as parse_1 } from "../fable_modules/fable-library-js.5.0.0-rc.2/Int32.js";
import Filter_Text from "../../public/assets/icons/Filter_Text.svg";
import Multiple_File_1 from "../../public/assets/icons/Multiple_File_1.svg";
import Download_File from "../../public/assets/icons/Download_File.svg";
import Delete_Circle from "../../public/assets/icons/Delete_Circle.svg";
import Upload_File from "../../public/assets/icons/Upload_File.svg";
import { Input } from "../Components/Input.js";
import Information_Circle from "../../public/assets/icons/Information_Circle.svg";
import Arrow_Down_3 from "../../public/assets/icons/Arrow_Down_3.svg";
import { Button } from "../Components/Button.js";

export class PrintMode extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["RangeItems", "ExcelFile"];
    }
}

export function PrintMode_$reflection() {
    return union_type("LabelPrint.View.PrintMode", [], PrintMode, () => [[], []]);
}

export class AveryTemplate extends Record {
    constructor(Id, Name, Width, Height, Cols, Rows, GapX, GapY) {
        super();
        this.Id = Id;
        this.Name = Name;
        this.Width = Width;
        this.Height = Height;
        this.Cols = (Cols | 0);
        this.Rows = (Rows | 0);
        this.GapX = GapX;
        this.GapY = GapY;
    }
}

export function AveryTemplate_$reflection() {
    return record_type("LabelPrint.View.AveryTemplate", [], AveryTemplate, () => [["Id", string_type], ["Name", string_type], ["Width", float64_type], ["Height", float64_type], ["Cols", int32_type], ["Rows", int32_type], ["GapX", float64_type], ["GapY", float64_type]]);
}

const templates = ofArray([new AveryTemplate("L7160", "Avery L7160 — 63,5 × 38,1 mm", 63.5, 38.1, 3, 7, 2.5, 0), new AveryTemplate("L7163", "Avery L7163 — 99,1 × 38,1 mm", 99.1, 38.1, 2, 7, 2.5, 0), new AveryTemplate("L7651", "Avery L7651 — 38,1 × 21,2 mm", 38.1, 21.2, 5, 13, 2.5, 0), new AveryTemplate("L4731", "Avery L4731 — 25,4 × 10,0 mm", 25.4, 10, 7, 27, 2.5, 0), new AveryTemplate("3666", "Avery 3666 — 70,0 × 37,0 mm", 70, 37, 3, 8, 0, 0), new AveryTemplate("Custom", "Benutzerdefiniert", 50, 30, 3, 8, 2.5, 0)]);

function findTemplate(id) {
    return defaultArg(tryFind((t) => (t.Id === id), templates), item(0, templates));
}

function QRPreview() {
    const finderCell = (i_1, j_1, ox, oy) => {
        const di = (i_1 - ox) | 0;
        const dj = (j_1 - oy) | 0;
        const m = max(Math.abs(di), Math.abs(dj)) | 0;
        if (m === 3) {
            return 1;
        }
        else if (m <= 1) {
            return 1;
        }
        else if (m === 2) {
            return 0;
        }
        else {
            return undefined;
        }
    };
    const rects = toList(delay(() => collect((row) => collect((col) => {
        let matchValue, matchValue_1, matchValue_2, i, j;
        return (((matchValue = finderCell(row, col, 3, 3), (matchValue == null) ? ((matchValue_1 = finderCell(row, col, 3, 21 - 4), (matchValue_1 == null) ? ((matchValue_2 = finderCell(row, col, 21 - 4, 3), (matchValue_2 == null) ? ((i = (row | 0), (j = (col | 0), ((i * 73856093) ^ (j * 19349663)) & (1 ^ ((i + j) & 1))))) : matchValue_2)) : matchValue_1)) : matchValue)) === 1) ? singleton(reactElement("rect", {
            x: col,
            y: row,
            width: 1,
            height: 1,
            fill: "currentColor",
        })) : empty();
    }, rangeDouble(0, 1, 21 - 1)), rangeDouble(0, 1, 21 - 1))));
    return reactElement("svg", {
        viewBox: (((((0 + " ") + 0) + " ") + 21) + " ") + 21,
        shapeRendering: "crispEdges",
        width: "100%",
        height: "100%",
        children: reactApi.Children.toArray(Array.from(rects)),
    });
}

function BarcodePreview() {
    let elements_1;
    const widths = new Int32Array([2, 1, 3, 1, 2, 3, 1, 2, 1, 3, 2, 1, 3, 1, 2, 3, 1, 2, 1, 2, 3, 1]);
    let x = 0;
    const bars = toList(delay(() => collect((i) => {
        const w = item_1(i, widths) | 0;
        return append(((i % 2) === 0) ? singleton(reactElement("rect", {
            x: x,
            y: 0,
            width: w,
            height: 24,
            fill: "currentColor",
        })) : empty(), delay(() => {
            x = (((x + w) + 1) | 0);
            return empty();
        }));
    }, rangeDouble(0, 1, widths.length - 1))));
    return reactElement("svg", createObj(ofArray([["viewBox", (((((0 + " ") + 0) + " ") + 55) + " ") + 30], ["preserveAspectRatio", "none"], ["width", "100%"], ["height", "100%"], (elements_1 = toList(delay(() => append(bars, delay(() => singleton(reactElement("text", {
        x: 27,
        y: 29,
        fill: "currentColor",
        fontSize: "3",
        textAnchor: "middle",
        fontFamily: "ui-monospace,monospace",
        children: reactApi.Children.toArray(["A03012"]),
    })))))), ["children", reactApi.Children.toArray(Array.from(elements_1))])])));
}

function SheetPreview(props) {
    let elems_1;
    const total = (props.Cols * props.Rows) | 0;
    const pages = ((props.FilledCount === 0) ? 1 : ~~Math.ceil(props.FilledCount / total)) | 0;
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-2"])], (elems_1 = toList(delay(() => {
        let elems;
        return append(singleton(reactElement("div", createObj(ofArray([["style", {
            display: "grid",
            gridTemplateColumns: join(" ", replicate(props.Cols, 1 + "fr")),
            gap: 2 + "px ",
            padding: 4,
            backgroundColor: "white",
            border: (((1 + "px ") + "solid") + " ") + "#E5E7EB",
            borderRadius: 4,
            width: 100 + "%",
            maxWidth: 130,
        }], (elems = toList(delay(() => map((i) => reactElement("div", {
            className: join(" ", toList(delay(() => append(singleton("rounded-sm"), delay(() => append(singleton("min-h-[3px]"), delay(() => ((i < props.FilledCount) ? singleton("bg-primary") : singleton("bg-gray-100"))))))))),
        }), rangeDouble(0, 1, total - 1)))), ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            const pagesLabel = (pages > 1) ? "Seiten" : "Seite";
            return singleton(reactElement("div", {
                className: join(" ", ["text-xs", "text-text-muted"]),
                children: `${props.Cols} × ${props.Rows} = ${total} pro Seite · ${pages} ${pagesLabel}`,
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function LabelPreview(props) {
    let elems_6, elems_5;
    const scale = min(320 / props.Width, (320 * 0.62) / props.Height);
    const w = ~~(props.Width * scale) | 0;
    const h = ~~(props.Height * scale) | 0;
    const cs = ~~(props.CodeSize * scale) | 0;
    const padPx = ~~(props.Padding * scale) | 0;
    const logoMaxHPx = ~~(props.LogoMaxHeight * scale) | 0;
    const textFontPx = max(5, ~~((props.TextFontSize * 0.353) * scale)) | 0;
    const codeValueFontPx = max(5, ~~((props.CodeValueFontSize * 0.353) * scale)) | 0;
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "items-center", "gap-2"])], (elems_6 = [reactElement("div", {
        className: join(" ", ["text-xs", "text-text-muted", "font-mono", "self-start", "w-full"]),
        children: toText(printf("%.1f × %.1f mm"))(props.Width)(props.Height),
    }), reactElement("div", createObj(ofArray([["style", {
        width: w + "px",
        height: h + "px",
        backgroundColor: "white",
        border: (((1 + "px ") + "solid") + " ") + "#E5E7EB",
        borderRadius: 4,
        position: "relative",
        overflow: "hidden",
    }], ["className", join(" ", ["shadow-md"])], (elems_5 = toList(delay(() => {
        let elems;
        return append(props.ShowCode ? append(singleton(reactElement("div", createObj(ofArray([["style", {
            position: "absolute",
            left: padPx + "px",
            top: padPx + "px",
            width: cs + "px",
            height: cs + "px",
            color: "#0F1419",
        }], (elems = toList(delay(() => ((props.CodeType.tag === 1) ? singleton(createElement(BarcodePreview, null)) : singleton(createElement(QRPreview, null))))), ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => (props.ShowCodeValue ? singleton(reactElement("div", {
            style: {
                position: "absolute",
                left: padPx + "px",
                top: ((padPx + cs) + ~~(1 * scale)) + "px",
                fontSize: codeValueFontPx + "px",
                fontFamily: "ui-monospace,monospace",
                color: "#4B5563",
            },
            children: reactApi.Children.toArray(["A03012"]),
        })) : empty()))) : empty(), delay(() => {
            let logoPositionStyle, matchValue_1, matchValue_2;
            return append(props.ShowLogo ? ((logoPositionStyle = ((matchValue_1 = props.LogoCorner, (matchValue_1.tag === 1) ? ofArray([["top", padPx + "px"], ["right", padPx + "px"]]) : ((matchValue_1.tag === 2) ? ofArray([["bottom", padPx + "px"], ["left", padPx + "px"]]) : ((matchValue_1.tag === 3) ? ofArray([["bottom", padPx + "px"], ["right", padPx + "px"]]) : ofArray([["top", padPx + "px"], ["left", padPx + "px"]]))))), (matchValue_2 = props.LogoDataUrl, (matchValue_2 == null) ? singleton(reactElement("div", {
                style: createObj(toList(delay(() => append(singleton(["position", "absolute"]), delay(() => append(logoPositionStyle, delay(() => append(singleton(["fontSize", 6 + "px"]), delay(() => append(singleton(["fontFamily", "ui-monospace,monospace"]), delay(() => append(singleton(["color", "#8A93A0"]), delay(() => append(singleton(["letterSpacing", 0.06 + "em"]), delay(() => append(singleton(["padding", ((2 + "px ") + 3) + "px"]), delay(() => append(singleton(["border", (((1 + "px ") + "dashed") + " ") + "#D1D5DB"]), delay(() => singleton(["borderRadius", 2])))))))))))))))))))),
                children: reactApi.Children.toArray(["LOGO"]),
            })) : singleton(reactElement("img", {
                src: matchValue_2,
                style: createObj(toList(delay(() => append(singleton(["position", "absolute"]), delay(() => append(logoPositionStyle, delay(() => append(singleton(["maxHeight", logoMaxHPx + "px"]), delay(() => append(singleton(["maxWidth", ~~((props.Width * scale) * 0.5) + "px"]), delay(() => singleton(["objectFit", "contain"])))))))))))),
            }))))) : empty(), delay(() => {
                let line1, line2, matchValue_3, elems_3;
                return append(props.ShowText ? ((line1 = ((props.TextLine1 === "") ? "Meine Firma GmbH" : props.TextLine1), (line2 = ((props.TextLine2 === "") ? "" : props.TextLine2), singleton(reactElement("div", createObj(ofArray([["style", createObj(ofArray([["position", "absolute"], ["left", padPx + "px"], ["bottom", padPx + "px"], ["right", padPx + "px"], ["fontSize", textFontPx + "px"], ["fontFamily", "ui-monospace,monospace"], ["color", "#0F1419"], ["fontWeight", 500], ["lineHeight", 1.3], ["display", "flex"], ["flexDirection", "column"], (matchValue_3 = props.TextAlign, (matchValue_3.tag === 1) ? ["textAlign", "center"] : ((matchValue_3.tag === 2) ? ["textAlign", "right"] : ["textAlign", "left"]))]))], (elems_3 = toList(delay(() => append(singleton(reactElement("span", {
                    children: line1,
                })), delay(() => ((line2 !== "") ? singleton(reactElement("span", {
                    children: line2,
                })) : empty()))))), ["children", reactApi.Children.toArray(Array.from(elems_3))])]))))))) : empty(), delay(() => (((!props.ShowCode && !props.ShowLogo) && !props.ShowText) ? singleton(reactElement("div", {
                    style: {
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: 8 + "px",
                        color: "#8A93A0",
                        textAlign: "center",
                        padding: 8,
                    },
                    children: reactApi.Children.toArray(["Leer – bitte eine Option aktivieren"]),
                })) : empty())));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_5))])])))], ["children", reactApi.Children.toArray(Array.from(elems_6))])])));
}

function ToggleSection(props) {
    let elems_3;
    return reactElement("div", createObj(ofArray([["className", join(" ", toList(delay(() => append(singleton("border"), delay(() => append(singleton("rounded-xl"), delay(() => append(singleton("overflow-hidden"), delay(() => append(singleton("transition-colors"), delay(() => (props.IsOn ? singleton("border-[#D5E9E4]") : singleton("border-border")))))))))))))], (elems_3 = toList(delay(() => {
        let elems_1, elems;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", toList(delay(() => append(singleton("flex"), delay(() => append(singleton("items-center"), delay(() => append(singleton("gap-3"), delay(() => append(singleton("px-4"), delay(() => append(singleton("py-3.5"), delay(() => append(singleton("cursor-pointer"), delay(() => (props.IsOn ? singleton("bg-[#FAFEFC]") : singleton("bg-white")))))))))))))))))], ["onClick", (_arg) => {
            props.OnToggle(!props.IsOn);
        }], (elems_1 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex-1"])], (elems = [reactElement("div", {
            className: join(" ", ["text-sm", "font-semibold", "text-black"]),
            children: props.Label,
        }), reactElement("div", {
            className: join(" ", ["text-xs", "text-text-muted", "mt-0.5"]),
            children: props.SubLabel,
        })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement(Toggle, {
            Checked: props.IsOn,
            OnChange: props.OnToggle,
        })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
            let child;
            const matchValue = props.Children;
            let matchResult, child_1;
            if (matchValue != null) {
                if ((child = matchValue, props.IsOn)) {
                    matchResult = 0;
                    child_1 = matchValue;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0:
                    return singleton(reactElement("div", {
                        className: join(" ", ["px-4", "pb-4", "pt-3", "border-t", "border-[#EEF0F3]", "bg-[#FAFEFC]"]),
                        children: reactApi.Children.toArray([child_1]),
                    }));
                default: {
                    return empty();
                }
            }
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

function SectionCard(props) {
    let elems_3, elems_1;
    return reactElement("div", createObj(ofArray([["className", join(" ", ["bg-white", "border", "border-border", "rounded-xl", "shadow-sm", "overflow-hidden"])], (elems_3 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "gap-3.5", "px-5", "py-4", "border-b", "border-[#EEF0F3]"])], (elems_1 = toList(delay(() => {
        let matchValue, n;
        return append((matchValue = props.StepNumber, (matchValue == null) ? (empty()) : ((n = (matchValue | 0), singleton(reactElement("div", {
            className: join(" ", ["w-6", "h-6", "rounded-full", "bg-teal-50", "text-primary", "text-xs", "font-semibold", "flex", "items-center", "justify-center", "flex-shrink-0"]),
            children: int32ToString(n),
        }))))), delay(() => {
            let elems;
            return singleton(reactElement("div", createObj(singleton_1((elems = [reactElement("div", {
                className: join(" ", ["text-base", "font-semibold", "text-black", "tracking-tight"]),
                children: props.Title,
            }), reactElement("div", {
                className: join(" ", ["text-xs", "text-text-muted", "mt-0.5"]),
                children: props.SubTitle,
            })], ["children", reactApi.Children.toArray(Array.from(elems))])))));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), reactElement("div", {
        className: join(" ", ["p-5"]),
        children: reactApi.Children.toArray([props.Children]),
    })], ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

function StepperInput(props) {
    let elems_3, elems_2;
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-1.5"])], (elems_3 = [reactElement("label", {
        className: join(" ", ["text-xs", "font-medium", "text-text-muted"]),
        children: props.Label,
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "border", "border-[#B6BECB]", "rounded-lg", "bg-white", "overflow-hidden", "h-10"])], (elems_2 = [reactElement("button", {
        className: join(" ", ["w-8", "h-full", "flex", "items-center", "justify-center", "text-text-muted", "hover:bg-gray-50", "cursor-pointer", "border-r", "border-[#B6BECB]", "text-base", "leading-none"]),
        onClick: (_arg) => {
            const v = round(props.Value - props.Step, 2);
            if (v >= props.Min) {
                props.OnChange(v);
            }
        },
        children: reactApi.Children.toArray(["−"]),
    }), reactElement("input", {
        className: join(" ", ["flex-1", "text-center", "text-sm", "font-mono", "border-0", "focus:outline-none", "bg-transparent", "h-full"]),
        value: toText(printf("%.1f"))(props.Value),
        onChange: (ev) => {
            const e = ev.target.value;
            try {
                const v_1 = parse(replace(e, ",", "."));
                if ((v_1 >= props.Min) && (v_1 <= props.Max)) {
                    props.OnChange(v_1);
                }
            }
            catch (matchValue) {
            }
        },
    }), reactElement("span", {
        className: join(" ", ["pr-2", "text-xs", "text-text-muted", "whitespace-nowrap", "flex-shrink-0"]),
        children: props.Unit,
    }), reactElement("button", {
        className: join(" ", ["w-8", "h-full", "flex", "items-center", "justify-center", "text-text-muted", "hover:bg-gray-50", "cursor-pointer", "border-l", "border-[#B6BECB]", "text-base", "leading-none"]),
        onClick: (_arg_1) => {
            const v_2 = round(props.Value + props.Step, 2);
            if (v_2 <= props.Max) {
                props.OnChange(v_2);
            }
        },
        children: reactApi.Children.toArray(["+"]),
    })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

function SegControl(props) {
    let elems;
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "p-1", "bg-gray-100", "rounded-lg", "gap-1"])], (elems = toList(delay(() => map((opt) => reactElement("button", {
        className: join(" ", toList(delay(() => append(singleton("flex-1"), delay(() => append(singleton("px-3"), delay(() => append(singleton("py-1.5"), delay(() => append(singleton("rounded-md"), delay(() => append(singleton("text-sm"), delay(() => append(singleton("font-medium"), delay(() => append(singleton("transition-colors"), delay(() => append(singleton("cursor-pointer"), delay(() => (equals(opt.Value, props.Selected) ? singleton("bg-white text-black shadow-sm") : singleton("text-text-muted hover:text-black"))))))))))))))))))))),
        onClick: (_arg) => {
            props.OnChange(opt.Value);
        },
        children: opt.Label,
    }), props.Options))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function ModeCard(props) {
    let elems_2, elems_1;
    return reactElement("button", createObj(ofArray([["className", join(" ", toList(delay(() => append(singleton("flex"), delay(() => append(singleton("items-start"), delay(() => append(singleton("gap-3"), delay(() => append(singleton("p-3.5"), delay(() => append(singleton("rounded-xl"), delay(() => append(singleton("border"), delay(() => append(singleton("text-left"), delay(() => append(singleton("w-full"), delay(() => append(singleton("transition-colors"), delay(() => append(singleton("cursor-pointer"), delay(() => (props.IsSelected ? singleton("border-primary bg-teal-50") : singleton("border-border bg-white hover:border-gray-300")))))))))))))))))))))))))], ["onClick", (_arg) => {
        props.OnSelect();
    }], (elems_2 = [reactElement("div", {
        className: join(" ", toList(delay(() => append(singleton("w-8"), delay(() => append(singleton("h-8"), delay(() => append(singleton("rounded-lg"), delay(() => append(singleton("flex"), delay(() => append(singleton("items-center"), delay(() => append(singleton("justify-center"), delay(() => append(singleton("flex-shrink-0"), delay(() => (props.IsSelected ? singleton("bg-white text-primary") : singleton("bg-gray-100 text-text-muted"))))))))))))))))))),
        children: reactApi.Children.toArray([props.Icon]),
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex-1", "min-w-0"])], (elems_1 = [reactElement("div", {
        className: join(" ", ["text-sm", "font-semibold", "text-black"]),
        children: props.Label,
    }), reactElement("div", {
        className: join(" ", ["text-xs", "text-text-muted", "mt-0.5", "leading-snug"]),
        children: props.Description,
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

export function LabelPrintPage() {
    let elems_61, elems, elems_60, elems_49, Title, SubTitle, elems_19, Title_1, SubTitle_1, elems_38, Label_4, SubLabel, elems_24, Label_7, SubLabel_1, elems_34, elems_31, elems_33, elems_32, Label_9, SubLabel_2, elems_37, elems_36, elems_35, Title_2, SubTitle_2, elems_48, elems_42, elems_41, elems_39, elems_40, elems_43, elems_44, elems_47, elems_46, elems_59, elems_58;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(new PrintMode(0, []));
    const setMode = patternInput_1[1];
    const mode = patternInput_1[0];
    const patternInput_2 = reactApi.useState("A03000");
    const rangeFrom = patternInput_2[0];
    const patternInput_3 = reactApi.useState("A03020");
    const rangeTo = patternInput_3[0];
    const patternInput_4 = reactApi.useState(empty_1());
    const setExcelRows = patternInput_4[1];
    const excelRows = patternInput_4[0];
    const patternInput_5 = reactApi.useState(undefined);
    const setExcelFileName = patternInput_5[1];
    const excelFileName = patternInput_5[0];
    const patternInput_6 = reactApi.useState(false);
    const setIsDragOver = patternInput_6[1];
    const isDragOver = patternInput_6[0];
    const patternInput_7 = reactApi.useState(undefined);
    const setLogoDataUrl = patternInput_7[1];
    const logoDataUrl = patternInput_7[0];
    const patternInput_8 = reactApi.useState(false);
    const setIsLogoDragOver = patternInput_8[1];
    const isLogoDragOver = patternInput_8[0];
    const readLogoFile = (file) => {
        const reader = new FileReader();
        reader.onload = ((_arg) => {
            setLogoDataUrl(reader.result);
        });
        reader.readAsDataURL(file);
    };
    const patternInput_9 = reactApi.useState(true);
    const showCode = patternInput_9[0];
    const patternInput_10 = reactApi.useState(new CodeType(0, []));
    const codeType = patternInput_10[0];
    const patternInput_11 = reactApi.useState(20);
    const codeSize = patternInput_11[0];
    const patternInput_12 = reactApi.useState(false);
    const showCodeValue = patternInput_12[0];
    const patternInput_13 = reactApi.useState(6);
    const codeValueFontSize = patternInput_13[0];
    const patternInput_14 = reactApi.useState(false);
    const showLogo = patternInput_14[0];
    const patternInput_15 = reactApi.useState(8);
    const logoMaxHeight = patternInput_15[0];
    const patternInput_16 = reactApi.useState(new LogoCorner(1, []));
    const logoCorner = patternInput_16[0];
    const patternInput_17 = reactApi.useState(true);
    const showText = patternInput_17[0];
    const patternInput_18 = reactApi.useState("");
    const textLine1 = patternInput_18[0];
    const patternInput_19 = reactApi.useState("");
    const textLine2 = patternInput_19[0];
    const patternInput_20 = reactApi.useState(6);
    const textFontSize = patternInput_20[0];
    const patternInput_21 = reactApi.useState(new TextAlign(0, []));
    const textAlign = patternInput_21[0];
    const patternInput_22 = reactApi.useState(1.5);
    const padding = patternInput_22[0];
    const patternInput_23 = reactApi.useState("L7160");
    const setSelectedTemplateId = patternInput_23[1];
    const selectedTemplateId = patternInput_23[0];
    const patternInput_24 = reactApi.useState(63.5);
    const setCustomWidth = patternInput_24[1];
    const patternInput_25 = reactApi.useState(38.1);
    const setCustomHeight = patternInput_25[1];
    const patternInput_26 = reactApi.useState(3);
    const setCustomCols = patternInput_26[1];
    const patternInput_27 = reactApi.useState(7);
    const setCustomRows = patternInput_27[1];
    const currentTemplate = findTemplate(selectedTemplateId);
    const isCustom = selectedTemplateId === "Custom";
    const labelWidth = isCustom ? patternInput_24[0] : currentTemplate.Width;
    const labelHeight = isCustom ? patternInput_25[0] : currentTemplate.Height;
    const sheetCols = (isCustom ? ~~patternInput_26[0] : currentTemplate.Cols) | 0;
    const sheetRows = (isCustom ? ~~patternInput_27[0] : currentTemplate.Rows) | 0;
    const perPage = (sheetCols * sheetRows) | 0;
    let labelCount;
    if (mode.tag === 1) {
        labelCount = length(excelRows);
    }
    else {
        let fromNum;
        const s = filter(isDigit, rangeFrom);
        fromNum = ((s === "") ? undefined : parse_1(s, 511, false, 32));
        let toNum;
        const s_1 = filter(isDigit, rangeTo);
        toNum = ((s_1 === "") ? undefined : parse_1(s_1, 511, false, 32));
        let matchResult, f_1, t_2;
        if (fromNum != null) {
            if (toNum != null) {
                if (toNum >= fromNum) {
                    matchResult = 0;
                    f_1 = fromNum;
                    t_2 = toNum;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0: {
                labelCount = ((t_2 - f_1) + 1);
                break;
            }
            default:
                labelCount = 0;
        }
    }
    const canDownload = (labelCount > 0) && ((showCode ? true : showLogo) ? true : showText);
    const pageCount = ((labelCount === 0) ? 1 : ~~Math.ceil(labelCount / perPage)) | 0;
    const labelsText = t("label_print.labels");
    return reactElement("div", createObj(ofArray([["className", join(" ", ["p-6", "max-w-[1400px]"])], (elems_61 = [reactElement("div", createObj(ofArray([["className", join(" ", ["mb-6"])], (elems = [reactElement("h1", {
        className: join(" ", ["text-3xl", "font-bold", "text-black", "tracking-tight"]),
        children: t("label_print.title"),
    }), reactElement("p", {
        className: join(" ", ["text-sm", "text-text-muted", "mt-1"]),
        children: t("label_print.subtitle"),
    })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-6", "items-start", "xl:grid-cols-[1fr_400px]"])], (elems_60 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-4"])], (elems_49 = [createElement(SectionCard, (Title = t("label_print.step1_title"), (SubTitle = t("label_print.step1_subtitle"), {
        Children: reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-4"])], (elems_19 = toList(delay(() => {
            let elems_3, Label, Description, IsSelected, elems_1, Label_1, Description_1, IsSelected_1, elems_2;
            return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-2", "gap-3"])], (elems_3 = [createElement(ModeCard, (Label = t("label_print.mode_range"), (Description = t("label_print.mode_range_desc"), (IsSelected = equals(mode, new PrintMode(0, [])), {
                Description: Description,
                Icon: reactElement("div", createObj(ofArray([["className", join(" ", ["h-5", "w-5"])], (elems_1 = [Filter_Text()], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))),
                IsSelected: IsSelected,
                Label: Label,
                OnSelect: () => {
                    setMode(new PrintMode(0, []));
                },
            })))), createElement(ModeCard, (Label_1 = t("label_print.mode_excel"), (Description_1 = t("label_print.mode_excel_desc"), (IsSelected_1 = equals(mode, new PrintMode(1, [])), {
                Description: Description_1,
                Icon: reactElement("div", createObj(ofArray([["className", join(" ", ["h-5", "w-5"])], (elems_2 = [Multiple_File_1()], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))),
                IsSelected: IsSelected_1,
                Label: Label_1,
                OnSelect: () => {
                    setMode(new PrintMode(1, []));
                },
            }))))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))), delay(() => {
                let elems_18, elems_9, elems_8, elems_17, elems_7;
                return (mode.tag === 1) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-3"])], (elems_18 = [reactElement("button", createObj(ofArray([["className", join(" ", ["flex", "items-center", "gap-2", "self-start", "px-3", "py-2", "rounded-lg", "border", "border-border", "bg-white", "text-sm", "font-medium", "text-black", "hover:border-primary", "hover:text-primary", "cursor-pointer", "transition-colors"])], ["onClick", (_arg_1) => {
                    downloadTemplate();
                }], (elems_9 = [reactElement("div", createObj(ofArray([["className", join(" ", ["h-4", "w-4"])], (elems_8 = [Download_File()], ["children", reactApi.Children.toArray(Array.from(elems_8))])]))), reactElement("span", {
                    children: t("label_print.excel_download_template"),
                })], ["children", reactApi.Children.toArray(Array.from(elems_9))])]))), reactElement("div", createObj(ofArray([["className", join(" ", toList(delay(() => append(singleton("border-2"), delay(() => append(singleton("border-dashed"), delay(() => append(singleton("rounded-xl"), delay(() => append(singleton("transition-colors"), delay(() => (isDragOver ? singleton("border-primary bg-teal-50") : ((excelFileName != null) ? singleton("border-[#D5E9E4] bg-[#FAFEFC]") : singleton("border-border bg-white hover:border-gray-300 hover:bg-gray-50 cursor-pointer"))))))))))))))], ["onClick", (_arg_2) => {
                    if (excelFileName == null) {
                        document.getElementById("label-print-excel-upload").click();
                    }
                }], ["onDragOver", (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    if (excelFileName == null) {
                        setIsDragOver(true);
                    }
                }], ["onDragLeave", (e_1) => {
                    e_1.preventDefault();
                    e_1.stopPropagation();
                    setIsDragOver(false);
                }], ["onDrop", (e_2) => {
                    e_2.preventDefault();
                    e_2.stopPropagation();
                    setIsDragOver(false);
                    if (excelFileName == null) {
                        const files = e_2.dataTransfer.files;
                        if (files.length > 0) {
                            const file_1 = files[0];
                            setExcelFileName(file_1.name);
                            parseExcelFile(file_1, setExcelRows);
                        }
                    }
                }], (elems_17 = toList(delay(() => append(singleton(reactElement("input", {
                    id: "label-print-excel-upload",
                    className: join(" ", ["hidden"]),
                    type: "file",
                    accept: ".xlsx,.xls",
                    onChange: (ev) => {
                        const files_1 = ev.target.files;
                        if (!(files_1 == null) && (files_1.length > 0)) {
                            const file_2 = files_1.item(0);
                            setExcelFileName(file_2.name);
                            parseExcelFile(file_2, setExcelRows);
                        }
                    },
                })), delay(() => {
                    let elems_16, elems_12, elems_13, elems_15, elems_14, elems_11, elems_10;
                    const matchValue_2 = excelFileName;
                    if (matchValue_2 != null) {
                        const name_19 = matchValue_2;
                        return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "gap-3", "px-4", "py-3"])], (elems_16 = [reactElement("div", createObj(ofArray([["className", join(" ", ["h-5", "w-5", "text-primary", "flex-shrink-0"])], (elems_12 = [Multiple_File_1()], ["children", reactApi.Children.toArray(Array.from(elems_12))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["flex-1", "min-w-0"])], (elems_13 = toList(delay(() => append(singleton(reactElement("p", {
                            className: join(" ", ["text-sm", "font-medium", "text-black", "truncate"]),
                            children: name_19,
                        })), delay(() => {
                            let arg_2;
                            return (length(excelRows) > 0) ? singleton(reactElement("p", {
                                className: join(" ", ["text-xs", "text-text-muted"]),
                                children: (arg_2 = (length(excelRows) | 0), toText(printf("%d %s"))(arg_2)(labelsText)),
                            })) : empty();
                        })))), ["children", reactApi.Children.toArray(Array.from(elems_13))])]))), reactElement("button", createObj(ofArray([["className", join(" ", ["flex-shrink-0", "p-1.5", "rounded-lg", "text-text-muted", "hover:bg-gray-100", "hover:text-black", "transition-colors", "cursor-pointer"])], ["onClick", (e_3) => {
                            e_3.stopPropagation();
                            setExcelFileName(undefined);
                            setExcelRows(empty_1());
                        }], (elems_15 = [reactElement("div", createObj(ofArray([["className", join(" ", ["h-4", "w-4"])], (elems_14 = [Delete_Circle()], ["children", reactApi.Children.toArray(Array.from(elems_14))])])))], ["children", reactApi.Children.toArray(Array.from(elems_15))])])))], ["children", reactApi.Children.toArray(Array.from(elems_16))])]))));
                    }
                    else {
                        return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "items-center", "justify-center", "gap-2", "py-6", "px-4"])], (elems_11 = [reactElement("div", createObj(ofArray([["className", join(" ", toList(delay(() => append(singleton("w-10"), delay(() => append(singleton("h-10"), delay(() => append(singleton("rounded-full"), delay(() => append(singleton("flex"), delay(() => append(singleton("items-center"), delay(() => append(singleton("justify-center"), delay(() => (isDragOver ? singleton("bg-primary/10 text-primary") : singleton("bg-gray-100 text-text-muted")))))))))))))))))], (elems_10 = [Upload_File()], ["children", reactApi.Children.toArray(Array.from(elems_10))])]))), reactElement("p", {
                            className: join(" ", ["text-sm", "font-medium", "text-black", "text-center"]),
                            children: t("label_print.excel_drop"),
                        }), reactElement("p", {
                            className: join(" ", ["text-xs", "text-text-muted"]),
                            children: ".xlsx · .xls",
                        })], ["children", reactApi.Children.toArray(Array.from(elems_11))])]))));
                    }
                })))), ["children", reactApi.Children.toArray(Array.from(elems_17))])])))], ["children", reactApi.Children.toArray(Array.from(elems_18))])])))) : singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-3"])], (elems_7 = toList(delay(() => {
                    let elems_4;
                    return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-2", "gap-4"])], (elems_4 = [createElement(Input, {
                        ComponentState: "enabled",
                        Label: t("label_print.range_from"),
                        OnChange: patternInput_2[1],
                        TestId: "label-print-range-from",
                        Value: rangeFrom,
                    }), createElement(Input, {
                        ComponentState: "enabled",
                        Label: t("label_print.range_to"),
                        OnChange: patternInput_3[1],
                        TestId: "label-print-range-to",
                        Value: rangeTo,
                    })], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))), delay(() => {
                        let elems_6, elems_5;
                        return (labelCount > 0) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "gap-2", "px-3", "py-2.5", "bg-teal-50", "border", "border-teal-100", "rounded-lg", "text-sm", "text-primary", "font-medium"])], (elems_6 = [reactElement("div", createObj(ofArray([["className", join(" ", ["h-4", "w-4"])], (elems_5 = [Information_Circle()], ["children", reactApi.Children.toArray(Array.from(elems_5))])]))), reactElement("span", {
                            children: toText(printf("%d %s in diesem Bereich"))(labelCount)(labelsText),
                        })], ["children", reactApi.Children.toArray(Array.from(elems_6))])])))) : empty();
                    }));
                })), ["children", reactApi.Children.toArray(Array.from(elems_7))])]))));
            }));
        })), ["children", reactApi.Children.toArray(Array.from(elems_19))])]))),
        StepNumber: 1,
        SubTitle: SubTitle,
        Title: Title,
    }))), createElement(SectionCard, (Title_1 = t("label_print.step2_title"), (SubTitle_1 = t("label_print.step2_subtitle"), {
        Children: reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-3"])], (elems_38 = [createElement(ToggleSection, (Label_4 = t("label_print.code_label"), (SubLabel = t("label_print.code_sublabel"), {
            Children: reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-4"])], (elems_24 = toList(delay(() => {
                let elems_21, elems_20;
                return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-2", "gap-4"])], (elems_21 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-1.5"])], (elems_20 = [reactElement("label", {
                    className: join(" ", ["text-xs", "font-medium", "text-text-muted"]),
                    children: t("label_print.code_type"),
                }), createElement(SegControl, {
                    OnChange: patternInput_10[1],
                    Options: ofArray([{
                        Label: "QR-Code",
                        Value: new CodeType(0, []),
                    }, {
                        Label: "Barcode",
                        Value: new CodeType(1, []),
                    }]),
                    Selected: codeType,
                })], ["children", reactApi.Children.toArray(Array.from(elems_20))])]))), createElement(StepperInput, {
                    Label: t("label_print.code_size"),
                    Max: 100,
                    Min: 5,
                    OnChange: patternInput_11[1],
                    Step: 1,
                    Unit: "mm",
                    Value: codeSize,
                })], ["children", reactApi.Children.toArray(Array.from(elems_21))])])))), delay(() => {
                    let elems_23, elems_22;
                    return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "justify-between", "py-1"])], (elems_23 = [reactElement("div", createObj(singleton_1((elems_22 = [reactElement("div", {
                        className: join(" ", ["text-sm", "font-medium", "text-black"]),
                        children: t("label_print.show_code_value"),
                    }), reactElement("div", {
                        className: join(" ", ["text-xs", "text-text-muted", "mt-0.5"]),
                        children: t("label_print.show_code_value_desc"),
                    })], ["children", reactApi.Children.toArray(Array.from(elems_22))])))), createElement(Toggle, {
                        Checked: showCodeValue,
                        OnChange: patternInput_12[1],
                    })], ["children", reactApi.Children.toArray(Array.from(elems_23))])])))), delay(() => (showCodeValue ? singleton(createElement(StepperInput, {
                        Label: t("label_print.code_value_font_size"),
                        Max: 20,
                        Min: 4,
                        OnChange: patternInput_13[1],
                        Step: 0.5,
                        Unit: "pt",
                        Value: codeValueFontSize,
                    })) : empty())));
                }));
            })), ["children", reactApi.Children.toArray(Array.from(elems_24))])]))),
            IsOn: showCode,
            Label: Label_4,
            OnToggle: patternInput_9[1],
            SubLabel: SubLabel,
        }))), createElement(ToggleSection, (Label_7 = t("label_print.logo_label"), (SubLabel_1 = t("label_print.logo_sublabel"), {
            Children: reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-3"])], (elems_34 = [reactElement("div", createObj(ofArray([["className", join(" ", toList(delay(() => append(singleton("border-2"), delay(() => append(singleton("border-dashed"), delay(() => append(singleton("rounded-xl"), delay(() => append(singleton("transition-colors"), delay(() => (isLogoDragOver ? singleton("border-primary bg-teal-50") : ((logoDataUrl != null) ? singleton("border-[#D5E9E4] bg-[#FAFEFC]") : singleton("border-border bg-white hover:border-gray-300 hover:bg-gray-50 cursor-pointer"))))))))))))))], ["onClick", (_arg_3) => {
                if (logoDataUrl == null) {
                    document.getElementById("label-print-logo-upload").click();
                }
            }], ["onDragOver", (e_4) => {
                e_4.preventDefault();
                e_4.stopPropagation();
                if (logoDataUrl == null) {
                    setIsLogoDragOver(true);
                }
            }], ["onDragLeave", (e_5) => {
                e_5.preventDefault();
                e_5.stopPropagation();
                setIsLogoDragOver(false);
            }], ["onDrop", (e_6) => {
                e_6.preventDefault();
                e_6.stopPropagation();
                setIsLogoDragOver(false);
                if (logoDataUrl == null) {
                    const files_2 = e_6.dataTransfer.files;
                    if (files_2.length > 0) {
                        readLogoFile(files_2[0]);
                    }
                }
            }], (elems_31 = toList(delay(() => append(singleton(reactElement("input", {
                id: "label-print-logo-upload",
                className: join(" ", ["hidden"]),
                type: "file",
                accept: "image/*",
                onChange: (ev_1) => {
                    const files_3 = ev_1.target.files;
                    if (!(files_3 == null) && (files_3.length > 0)) {
                        readLogoFile(files_3.item(0));
                    }
                },
            })), delay(() => {
                let elems_30, elems_27, elems_29, elems_28, elems_26, elems_25;
                const matchValue_3 = logoDataUrl;
                if (matchValue_3 != null) {
                    const dataUrl = matchValue_3;
                    return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "gap-3", "px-4", "py-3"])], (elems_30 = [reactElement("img", {
                        src: dataUrl,
                        className: join(" ", ["h-10", "w-auto", "object-contain", "flex-shrink-0", "rounded"]),
                    }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex-1", "min-w-0"])], (elems_27 = [reactElement("p", {
                        className: join(" ", ["text-sm", "font-medium", "text-black"]),
                        children: t("label_print.logo_loaded"),
                    }), reactElement("p", {
                        className: join(" ", ["text-xs", "text-text-muted"]),
                        children: t("label_print.logo_replace_hint"),
                    })], ["children", reactApi.Children.toArray(Array.from(elems_27))])]))), reactElement("button", createObj(ofArray([["className", join(" ", ["flex-shrink-0", "p-1.5", "rounded-lg", "text-text-muted", "hover:bg-gray-100", "hover:text-black", "transition-colors", "cursor-pointer"])], ["onClick", (e_7) => {
                        e_7.stopPropagation();
                        setLogoDataUrl(undefined);
                    }], (elems_29 = [reactElement("div", createObj(ofArray([["className", join(" ", ["h-4", "w-4"])], (elems_28 = [Delete_Circle()], ["children", reactApi.Children.toArray(Array.from(elems_28))])])))], ["children", reactApi.Children.toArray(Array.from(elems_29))])])))], ["children", reactApi.Children.toArray(Array.from(elems_30))])]))));
                }
                else {
                    return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "items-center", "justify-center", "gap-2", "py-5", "px-4"])], (elems_26 = [reactElement("div", createObj(ofArray([["className", join(" ", toList(delay(() => append(singleton("w-10"), delay(() => append(singleton("h-10"), delay(() => append(singleton("rounded-full"), delay(() => append(singleton("flex"), delay(() => append(singleton("items-center"), delay(() => append(singleton("justify-center"), delay(() => (isLogoDragOver ? singleton("bg-primary/10 text-primary") : singleton("bg-gray-100 text-text-muted")))))))))))))))))], (elems_25 = [Upload_File()], ["children", reactApi.Children.toArray(Array.from(elems_25))])]))), reactElement("p", {
                        className: join(" ", ["text-sm", "font-medium", "text-black", "text-center"]),
                        children: t("label_print.logo_drop"),
                    }), reactElement("p", {
                        className: join(" ", ["text-xs", "text-text-muted"]),
                        children: "PNG · JPG · SVG · WebP",
                    })], ["children", reactApi.Children.toArray(Array.from(elems_26))])]))));
                }
            })))), ["children", reactApi.Children.toArray(Array.from(elems_31))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-2", "gap-4"])], (elems_33 = [createElement(StepperInput, {
                Label: t("label_print.logo_max_height"),
                Max: 30,
                Min: 2,
                OnChange: patternInput_15[1],
                Step: 0.5,
                Unit: "mm",
                Value: logoMaxHeight,
            }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-1.5"])], (elems_32 = [reactElement("label", {
                className: join(" ", ["text-xs", "font-medium", "text-text-muted"]),
                children: t("label_print.logo_corner"),
            }), createElement(SegControl, {
                OnChange: patternInput_16[1],
                Options: ofArray([{
                    Label: "↖",
                    Value: new LogoCorner(0, []),
                }, {
                    Label: "↗",
                    Value: new LogoCorner(1, []),
                }, {
                    Label: "↙",
                    Value: new LogoCorner(2, []),
                }, {
                    Label: "↘",
                    Value: new LogoCorner(3, []),
                }]),
                Selected: logoCorner,
            })], ["children", reactApi.Children.toArray(Array.from(elems_32))])])))], ["children", reactApi.Children.toArray(Array.from(elems_33))])])))], ["children", reactApi.Children.toArray(Array.from(elems_34))])]))),
            IsOn: showLogo,
            Label: Label_7,
            OnToggle: patternInput_14[1],
            SubLabel: SubLabel_1,
        }))), createElement(ToggleSection, (Label_9 = t("label_print.text_label"), (SubLabel_2 = t("label_print.text_sublabel"), {
            Children: reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-3"])], (elems_37 = [createElement(Input, {
                ComponentState: "enabled",
                Label: t("label_print.text_line1"),
                OnChange: patternInput_18[1],
                TestId: "label-print-text-line1",
                Value: textLine1,
            }), createElement(Input, {
                ComponentState: "enabled",
                Label: t("label_print.text_line2"),
                OnChange: patternInput_19[1],
                TestId: "label-print-text-line2",
                Value: textLine2,
            }), reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-2", "gap-4"])], (elems_36 = [createElement(StepperInput, {
                Label: t("label_print.text_font_size"),
                Max: 24,
                Min: 4,
                OnChange: patternInput_20[1],
                Step: 0.5,
                Unit: "pt",
                Value: textFontSize,
            }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-1.5"])], (elems_35 = [reactElement("label", {
                className: join(" ", ["text-xs", "font-medium", "text-text-muted"]),
                children: t("label_print.text_align"),
            }), createElement(SegControl, {
                OnChange: patternInput_21[1],
                Options: ofArray([{
                    Label: t("label_print.align_left"),
                    Value: new TextAlign(0, []),
                }, {
                    Label: t("label_print.align_center"),
                    Value: new TextAlign(1, []),
                }, {
                    Label: t("label_print.align_right"),
                    Value: new TextAlign(2, []),
                }]),
                Selected: textAlign,
            })], ["children", reactApi.Children.toArray(Array.from(elems_35))])])))], ["children", reactApi.Children.toArray(Array.from(elems_36))])])))], ["children", reactApi.Children.toArray(Array.from(elems_37))])]))),
            IsOn: showText,
            Label: Label_9,
            OnToggle: patternInput_17[1],
            SubLabel: SubLabel_2,
        })))], ["children", reactApi.Children.toArray(Array.from(elems_38))])]))),
        StepNumber: 2,
        SubTitle: SubTitle_1,
        Title: Title_1,
    }))), createElement(SectionCard, (Title_2 = t("label_print.step3_title"), (SubTitle_2 = t("label_print.step3_subtitle"), {
        Children: reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-4"])], (elems_48 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-1.5"])], (elems_42 = [reactElement("label", {
            className: join(" ", ["text-xs", "font-medium", "text-text-muted"]),
            children: t("label_print.template_label"),
        }), reactElement("div", createObj(ofArray([["className", join(" ", ["relative"])], (elems_41 = [reactElement("select", createObj(ofArray([["className", join(" ", ["w-full", "appearance-none", "border", "border-[#B6BECB]", "rounded-lg", "px-3", "pr-9", "py-2.5", "text-sm", "bg-white", "focus:outline-none", "focus:border-primary", "cursor-pointer"])], ["value", selectedTemplateId], ["onChange", (ev_2) => {
            const v = ev_2.target.value;
            setSelectedTemplateId(v);
            const tpl = findTemplate(v);
            setCustomWidth(tpl.Width);
            setCustomHeight(tpl.Height);
            setCustomCols(tpl.Cols);
            setCustomRows(tpl.Rows);
        }], (elems_39 = toList(delay(() => map((tpl_1) => reactElement("option", {
            value: tpl_1.Id,
            children: (tpl_1.Id === "Custom") ? t("label_print.custom_template") : tpl_1.Name,
        }), templates))), ["children", reactApi.Children.toArray(Array.from(elems_39))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["absolute", "right-3", "top-1/2", "-translate-y-1/2", "h-4", "w-4", "text-text-muted", "pointer-events-none"])], (elems_40 = [Arrow_Down_3()], ["children", reactApi.Children.toArray(Array.from(elems_40))])])))], ["children", reactApi.Children.toArray(Array.from(elems_41))])])))], ["children", reactApi.Children.toArray(Array.from(elems_42))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-2", "gap-4"])], (elems_43 = [createElement(StepperInput, {
            Label: t("label_print.width"),
            Max: 300,
            Min: 5,
            OnChange: (v_1) => {
                setSelectedTemplateId("Custom");
                setCustomWidth(v_1);
            },
            Step: 0.5,
            Unit: "mm",
            Value: labelWidth,
        }), createElement(StepperInput, {
            Label: t("label_print.height"),
            Max: 300,
            Min: 5,
            OnChange: (v_2) => {
                setSelectedTemplateId("Custom");
                setCustomHeight(v_2);
            },
            Step: 0.5,
            Unit: "mm",
            Value: labelHeight,
        })], ["children", reactApi.Children.toArray(Array.from(elems_43))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-2", "gap-4"])], (elems_44 = [createElement(StepperInput, {
            Label: t("label_print.cols"),
            Max: 20,
            Min: 1,
            OnChange: (v_3) => {
                setSelectedTemplateId("Custom");
                setCustomCols(v_3);
            },
            Step: 1,
            Unit: t("label_print.cols_unit"),
            Value: sheetCols,
        }), createElement(StepperInput, {
            Label: t("label_print.rows"),
            Max: 40,
            Min: 1,
            OnChange: (v_4) => {
                setSelectedTemplateId("Custom");
                setCustomRows(v_4);
            },
            Step: 1,
            Unit: t("label_print.rows_unit"),
            Value: sheetRows,
        })], ["children", reactApi.Children.toArray(Array.from(elems_44))])]))), createElement(StepperInput, {
            Label: t("label_print.padding"),
            Max: 10,
            Min: 0,
            OnChange: patternInput_22[1],
            Step: 0.5,
            Unit: "mm",
            Value: padding,
        }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "gap-6", "p-4", "bg-gray-50", "rounded-xl", "border", "border-border"])], (elems_47 = [createElement(SheetPreview, {
            Cols: sheetCols,
            FilledCount: min(labelCount, perPage),
            Rows: sheetRows,
        }), reactElement("div", createObj(ofArray([["className", join(" ", ["text-sm", "text-text-muted", "flex", "flex-col", "gap-1.5"])], (elems_46 = toList(delay(() => {
            const formatLabel = t("label_print.summary_format");
            const perPageLabel = t("label_print.summary_per_page");
            const pagesLabel2 = t("label_print.summary_pages");
            return collect((matchValue_4) => {
                let elems_45;
                return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-between", "gap-6"])], (elems_45 = [reactElement("span", {
                    children: matchValue_4[0],
                }), reactElement("b", {
                    className: join(" ", ["text-black", "font-semibold"]),
                    children: matchValue_4[1],
                })], ["children", reactApi.Children.toArray(Array.from(elems_45))])]))));
            }, [[formatLabel, toText(printf("%.1f × %.1f mm"))(labelWidth)(labelHeight)], [perPageLabel, toText(printf("%d %s"))(perPage)(labelsText)], [pagesLabel2, int32ToString(pageCount)]]);
        })), ["children", reactApi.Children.toArray(Array.from(elems_46))])])))], ["children", reactApi.Children.toArray(Array.from(elems_47))])])))], ["children", reactApi.Children.toArray(Array.from(elems_48))])]))),
        StepNumber: 3,
        SubTitle: SubTitle_2,
        Title: Title_2,
    })))], ["children", reactApi.Children.toArray(Array.from(elems_49))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["xl:sticky", "xl:top-20"])], (elems_59 = [reactElement("div", createObj(ofArray([["className", join(" ", ["bg-white", "border", "border-border", "rounded-xl", "shadow-md", "p-5"])], (elems_58 = toList(delay(() => {
        let elems_51, elems_50;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-start", "justify-between", "gap-3", "mb-4"])], (elems_51 = [reactElement("div", createObj(singleton_1((elems_50 = [reactElement("div", {
            className: join(" ", ["text-[10px]", "uppercase", "tracking-widest", "text-text-muted", "font-semibold"]),
            children: t("label_print.preview"),
        }), reactElement("div", {
            className: join(" ", ["text-base", "font-semibold", "mt-0.5", "text-black", "break-words"]),
            children: (mode.tag === 1) ? defaultArgWith(excelFileName, () => t("label_print.no_file")) : ((rangeFrom + " – ") + rangeTo),
        })], ["children", reactApi.Children.toArray(Array.from(elems_50))])))), reactElement("span", {
            className: join(" ", ["px-2.5", "py-1", "rounded-full", "bg-teal-50", "text-primary", "text-xs", "font-semibold", "whitespace-nowrap"]),
            children: toText(printf("%d %s"))(labelCount)(labelsText),
        })], ["children", reactApi.Children.toArray(Array.from(elems_51))])])))), delay(() => {
            let elems_52;
            return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["bg-gray-50", "border", "border-[#EEF0F3]", "rounded-xl", "p-4", "flex", "flex-col", "items-center"])], (elems_52 = [createElement(LabelPreview, {
                CodeSize: codeSize,
                CodeType: codeType,
                CodeValueFontSize: codeValueFontSize,
                Height: labelHeight,
                LogoCorner: logoCorner,
                LogoDataUrl: unwrap(logoDataUrl),
                LogoMaxHeight: logoMaxHeight,
                Padding: padding,
                ShowCode: showCode,
                ShowCodeValue: showCodeValue,
                ShowLogo: showLogo,
                ShowText: showText,
                TextAlign: textAlign,
                TextFontSize: textFontSize,
                TextLine1: textLine1,
                TextLine2: textLine2,
                Width: labelWidth,
            })], ["children", reactApi.Children.toArray(Array.from(elems_52))])])))), delay(() => {
                let elems_53, Label_18;
                return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-2", "mt-4"])], (elems_53 = [createElement(Button, (Label_18 = t("label_print.download_pdf"), {
                    ComponentState: canDownload ? "enabled" : "disabled",
                    Icon: Download_File(),
                    Label: Label_18,
                    OnClick: () => {
                        generate((mode.tag === 1) ? excelRows : map_1((code) => (new LabelData(code, textLine1, textLine2)), generateRangeCodes(rangeFrom, rangeTo)), new LabelConfig(codeType, labelWidth, labelHeight, codeSize, showCode, showCodeValue, showText, textLine1, textLine2, showLogo, logoDataUrl, padding, logoMaxHeight, logoCorner, textFontSize, textAlign, codeValueFontSize), sheetCols, sheetRows, currentTemplate.GapX, currentTemplate.GapY);
                    },
                    TestId: "label-print-download-btn",
                    Variant: "primary",
                }))], ["children", reactApi.Children.toArray(Array.from(elems_53))])])))), delay(() => {
                    let elems_55, elems_54;
                    return append(!canDownload ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-start", "gap-2", "mt-3", "px-3", "py-2.5", "bg-amber-50", "border", "border-amber-100", "rounded-lg", "text-xs", "text-amber-700"])], (elems_55 = [reactElement("div", createObj(ofArray([["className", join(" ", ["h-3.5", "w-3.5", "flex-shrink-0", "mt-0.5"])], (elems_54 = [Information_Circle()], ["children", reactApi.Children.toArray(Array.from(elems_54))])]))), reactElement("span", {
                        children: (labelCount === 0) ? t("label_print.warn_no_source") : t("label_print.warn_no_content"),
                    })], ["children", reactApi.Children.toArray(Array.from(elems_55))])])))) : empty(), delay(() => {
                        let elems_57;
                        return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mt-4", "pt-4", "border-t", "border-[#EEF0F3]", "grid", "grid-cols-2", "gap-y-2", "gap-x-4"])], (elems_57 = toList(delay(() => collect((matchValue_5) => {
                            let elems_56;
                            return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-between", "gap-2", "text-xs"])], (elems_56 = [reactElement("span", {
                                className: join(" ", ["text-text-muted"]),
                                children: matchValue_5[0],
                            }), reactElement("b", {
                                className: join(" ", ["text-black", "font-semibold", "tabular-nums"]),
                                children: matchValue_5[1],
                            })], ["children", reactApi.Children.toArray(Array.from(elems_56))])]))));
                        }, [[t("label_print.summary_template"), isCustom ? t("label_print.custom_template") : currentTemplate.Name], [t("label_print.summary_format"), toText(printf("%.1f × %.1f mm"))(labelWidth)(labelHeight)], [t("label_print.summary_per_page"), toText(printf("%d %s"))(perPage)(labelsText)], [t("label_print.summary_pages"), int32ToString(pageCount)]]))), ["children", reactApi.Children.toArray(Array.from(elems_57))])]))));
                    }));
                }));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_58))])])))], ["children", reactApi.Children.toArray(Array.from(elems_59))])])))], ["children", reactApi.Children.toArray(Array.from(elems_60))])])))], ["children", reactApi.Children.toArray(Array.from(elems_61))])])));
}

